import Image from 'next/image';
import { Box } from '@xstyled/styled-components';
import { Container } from '@/UI/Layout/Container';
import { FlexBox } from '@/UI/Primitives/FlexBox';
import { SectionTitle } from '@/UI/Primitives/Headings';
import { BannerBox, BannerContainer, BannerImage } from './styles';

export default function BrandBanner({ brand, image, description }) {
  return (
    <BannerContainer p={{ _: '2.125rem 1rem', desktop: '2.125rem 2rem 3rem' }}>
      <Container>
        {image && (
          <BannerImage>
            <Image src={image} layout="fill" alt="Banner image" />
          </BannerImage>
        )}
        <FlexBox
          justify={{ _: 'center', desktop: 'start' }}
          mb={{ desktop: '5rem' }}
        >
          <BannerBox position="relative">
            <SectionTitle as="h1">{brand?.value}</SectionTitle>
            {brand?.image && (
              <Box
                as="span"
                position="absolute"
                right={16}
                top={16}
                zIndex={-1}
              >
                <Image
                  src={brand?.image}
                  alt={brand?.value}
                  width={100}
                  height={100}
                  layout="fixed"
                  objectFit="contain"
                  priority
                />
              </Box>
            )}
            <Box as="p" mt={{ _: '4.5rem', desktop: '2.5rem' }}>
              {description}
            </Box>
          </BannerBox>
        </FlexBox>
      </Container>
    </BannerContainer>
  );
}
